import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { getUserRole } from "../roleCrypto";

const API = process.env.REACT_APP_API_URL;
const userRole = getUserRole();

function Dashboard() {
  const [isOpen, setIsOpen] = useState(false);

  const [data, setData] = useState({
    total_users: 0,
    total_casefiles: 0,
    total_revenue: 0,
  });

  useEffect(() => {
    document.title = "Dashboard | Admin Panel";
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setData(res.data);
    } catch (err) {
      console.log(err);

      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  };


  return (
    <div className="flex min-h-screen bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50">
      
      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex-1 flex flex-col">

        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">

          <h2 className="text-3xl font-bold text-gray-800 mb-6">
            Welcome Back 👋
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            <div className="bg-white/70 backdrop-blur-lg p-6 rounded-2xl shadow hover:shadow-xl transition">
              <h3 className="text-gray-500">Users</h3>
              <p className="text-3xl font-bold">{data.total_users}</p>
            </div>
            {userRole !== "subadmin" && (
            <div className="bg-white/70 backdrop-blur-lg p-6 rounded-2xl shadow hover:shadow-xl transition">
              <h3 className="text-gray-500">Revenue</h3>
              <p className="text-3xl font-bold">
                AED {data.total_revenue}
              </p>
            </div>
            )}

            <div className="bg-white/70 backdrop-blur-lg p-6 rounded-2xl shadow hover:shadow-xl transition">
              <h3 className="text-gray-500">Case Files</h3>
              <p className="text-3xl font-bold">{data.total_casefiles}</p>
            </div>

          </div>

        </main>

      </div>
    </div>
  );
}

export default Dashboard;